import React, { Suspense } from 'react';
import { Card, Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import AppHeader from '../Header/Header';
import FooterArea from '../Footer/FooterArea';
import { ProductsProvider } from '../../context/ProductsContext';
import RouteLoading from '../Content/RouteLoading';

const { Content } = Layout;

export default function AccountPickerLayout() {
  return (
    <ProductsProvider>
    <Layout
      style={{
        minHeight: '100vh',
        maxHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <AppHeader className="app-header" />
      <Content
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          padding: '1%',
        }}
      >
        <Card
          style={{
            width: '100%',
            maxWidth: '2000px',
            margin: '0 auto',
            minHeight: 'calc(100vh - 140px)',
          }}
        >
          <Suspense fallback={<RouteLoading />}>
            <Outlet />
          </Suspense>
        </Card>
      </Content>
      <FooterArea />
    </Layout>
    </ProductsProvider>
  );
}
